import {ExamName, ExamType, ExamVersion} from './exam';
import {Category} from './category';
import React, {ReactNode} from "react";
import {BookOpen, FileText, LayoutTemplate, Lightbulb, Video, Volume, Volume2} from "lucide-react";

export type Resource = {
    id?: string,
    title?: string,
    description?: string,
    type?: ResourceType,
    content?: string,
    examRelevance?: ExamType[],
    examVersion?: ExamVersion,
    category?: Category[],
    readTime?: number,
    rating?: number,
    readCount?: number,
    reviewCount?: number,
}

export type ResourceType =
    | 'lesson'        // structured instructional content
    | 'template'      // pre-formatted structure (essay templates, speaking outlines, etc.)
    | 'guide'         // written guidance / strategy documents      // practice activities
    | 'reference'     // lists, tables, quick lookup (could include phrase banks)
    | 'video'         // video tutorials
    | 'audio'         // listening resources

export const RESOURCE_TYPE_MAP: { [key in ResourceType]?: string } = {
    audio: 'Audio',
    guide: 'Guide',
    lesson: 'Lesson',
    reference: 'Reference',
    template: 'Template',
    video: 'Video',
}

export const resourceTypeIconMap: { [key in ResourceType]?: ReactNode } = {
    audio: <Volume2 style={{color: "inherit", fontSize: 24}}/>,
    guide: <BookOpen style={{color: "inherit", fontSize: 24}}/>,
    lesson: <Lightbulb style={{color: "inherit", fontSize: 24}}/>,
    reference: <FileText style={{color: "inherit", fontSize: 24}}/>,
    template: <LayoutTemplate style={{color: "inherit", fontSize: 24}}/>,
    video: <Video style={{color: "inherit", fontSize: 24}}/>,
}

export const resourceTypeIconMapBig: { [key in ResourceType]?: ReactNode } = {
    audio: <Volume2 style={{color: "inherit", fontSize: 33}}/>,
    guide: <BookOpen style={{color: "inherit", fontSize: 33}}/>,
    lesson: <Lightbulb style={{color: "inherit", fontSize: 33}}/>,
    reference: <FileText style={{color: "inherit", fontSize: 33}}/>,
    template: <LayoutTemplate style={{color: "inherit", fontSize: 33}}/>,
    video: <Video style={{color: "inherit", fontSize: 33}}/>,
}

export const gradientPairs: { [key in ResourceType]: string[] } = {
    audio: ["#3b82f6", "#ff2dd3"],
    guide: ["turquoise", "green"],
    lesson: ["#3b82f6", "turquoise"],
    reference: ["red", "#ff2dd3"],
    template: ["#3b82f6", "#ff2dd3"],
    video: ["orange", "#ff2dd3"]
}
